<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Walking Farm&#174; Help</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <div class="tw:p-4 tw:text-justify">
    <h1 class="tw:py-4 tw:text-lg tw:font-bold tw:uppercase">Find farm area</h1>
    <p>
      The walking farm functionality allows you to select an area by drawing a polygon on the map. Once you choose an
      area you could download and save a list with information for all the properties that fall within that enclosed
      zone.
    </p>
    <h1 class="tw:py-4 tw:text-lg tw:font-bold tw:uppercase">To draw a polygon</h1>
    <ol class="tw:list-inside tw:list-decimal">
      <li class="tw:pb-2">
        To enter drawing mode select the floating button with the pencil icon.<br />
        <ion-button shape="round">
          <ion-icon slot="icon-only" src="/assets/svg/pencil.svg"></ion-icon>
        </ion-button>
      </li>
      <li class="tw:pb-2">
        Once you get into draw mode, tap on the screen to drop a point. Every time you tap, another connecting point
        will be added. The area that falls within the connected points would be colored in light blue.
      </li>
      <li class="tw:pb-2">
        To finish the selection click the Done button on right.<br />
        <ion-button shape="round">
          <ion-icon slot="icon-only" src="/assets/svg/check.svg"></ion-icon>
        </ion-button>
      </li>
      <li class="tw:pb-2">
        Once you have done your selection click the magic wand button to save the report.<br />
        <ion-button shape="round">
          <ion-icon slot="icon-only" src="/assets/svg/wand.svg"></ion-icon>
        </ion-button>
      </li>
      <li class="tw:pb-2">
        You could clear the entire selection by clicking the Erase button on left.<br />
        <ion-button fill="outline" shape="round">
          <ion-icon slot="icon-only" src="/assets/svg/eraser.svg"></ion-icon>
        </ion-button>
      </li>
    </ol>
  </div>
</red-page-content>
